const NAME = 'admin';
export const ADMIN_BASE_URL = 'admin/v2';
export default { NAME };
